<template>
  <div class="exe-pricing-container">

    <!-- 全屏成功遮罩层 -->
    <div v-if="paymentSuccess && showGlobalOverlay" class="global-success-overlay">
      <div class="overlay-background"></div>
      <div class="overlay-content">
        <div class="success-icon-large">
          <el-icon color="#52c41a" :size="40"><Check /></el-icon>
        </div>
        <h2 class="overlay-title">订阅成功！</h2>
        <p class="overlay-description">您的插件已成功激活，可以开始使用了</p>
        <button class="overlay-button" >确定</button>
      </div>
    </div>

    <div class="main-layout">
      <!-- 左边：套餐选择区域 (3/4) -->
      <div class="left-section">
        <div class="period-selection-section">

          <!-- 套餐卡片 -->
          <div class="period-horizontal-container">
            <div
                v-for="plan in plans"
                :key="plan.days"
                class="period-horizontal-option"
                :class="{
                'active': selectedPlan === plan.days,
                'popular': plan.days === 90,
                'premium': plan.days === 365
              }"
                @click="selectPlan(plan)"
            >
              <!-- 推荐角标 -->
              <div class="period-top-badge" v-if="plan.days === 90">推荐</div>
              <div class="period-top-badge" v-if="plan.days === 365">超值</div>

              <div class="period-main-content">
                <div class="period-label">{{ plan.name }}</div>
                <div class="period-price">
                  <span class="currency">¥</span>
                  <span class="amount">{{ plan.price }}</span>
                </div>
                <div class="period-days">{{ plan.days }}天</div>
                <div class="period-desc" v-if="plan.desc">{{ plan.desc }}</div>
                <div class="plan-original" v-if="plan.originalPrice && plan.originalPrice !== plan.price">
                  原价: ¥{{ plan.originalPrice }}
                </div>
              </div>

              <!-- 选中标记 -->
              <div class="period-check-mark" v-if="selectedPlan === plan.days">
                <el-icon><Check /></el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右边：二维码支付区域 (1/4) -->
      <div class="right-section">
        <!-- 价格显示区域 -->
        <div class="payment-amount" v-if="selectedPlanData">
          <div class="amount-label">支付金额</div>
          <div class="amount-value">¥{{ selectedPlanData.price }}</div>
        </div>

        <!-- 二维码区域 -->
        <div class="qrcode-section">
          <div class="qrcode-header">
            <el-icon>
              <svg t="1761617723278" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4874" width="28" height="28">
                <path d="M1024 619.52c0-143.36-138.24-256-307.2-256s-307.2 112.64-307.2 256 138.24 256 307.2 256c30.72 0 61.44-5.12 92.16-10.24l97.28 51.2-25.6-76.8c87.04-51.2 143.36-128 143.36-220.16z m-414.72-40.96c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z m209.92 0c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z" fill="#4CBF00" p-id="4875"></path>
                <path d="M358.4 609.28c0-158.72 153.6-286.72 348.16-286.72h15.36c-40.96-133.12-179.2-235.52-353.28-235.52-204.8 0-368.64 138.24-368.64 307.2c0 107.52 66.56 204.8 168.96 256l-30.72 92.16L256 686.08c35.84 10.24 71.68 15.36 112.64 15.36h10.24c-15.36-30.72-20.48-61.44-20.48-92.16z m138.24-414.72c35.84 0 66.56 30.72 66.56 66.56s-30.72 66.56-66.56 66.56C460.8 322.56 430.08 291.84 430.08 256S460.8 194.56 496.64 194.56zM245.76 322.56c-35.84 0-61.44-30.72-61.44-66.56s30.72-66.56 66.56-66.56 61.44 30.72 61.44 66.56-30.72 66.56-66.56 66.56z" fill="#4CBF00" p-id="4876"></path>
              </svg>
            </el-icon>
            微信扫码支付
          </div>

          <div class="qrcode-display-area">
            <!-- 二维码显示 -->
            <div class="qrcode-wrapper" v-if="!paymentSuccess && !paymentError && selectedPlanData && qrCodeUrl">
              <img :src="qrCodeUrl" alt="微信支付二维码" class="qrcode-image" />

              <!-- 支付成功遮罩 -->
              <div v-if="paymentStatus === 'success'" class="success-overlay">
                <div class="success-content">
                  <el-icon color="#52c41a" :size="40"><Check /></el-icon>
                  <p class="success-text">支付成功</p>
                  <p class="success-hint">插件已激活</p>
                </div>
              </div>

              <!-- 二维码过期遮罩 -->
              <div v-if="isQrCodeExpired && paymentStatus === 'pending'" class="expired-overlay" @click="refreshQrCode">
                <div class="expired-content">
                  <el-icon color="#f56c6c" :size="24"><Refresh /></el-icon>
                  <p class="expired-text">二维码已过期</p>
                  <p class="expired-hint">点击刷新二维码</p>
                </div>
              </div>
            </div>

<!--            &lt;!&ndash; 支付成功 &ndash;&gt;-->
<!--            <div class="success-section" v-if="paymentSuccess && !qrCodeUrl">-->
<!--              <div class="success-icon">✓</div>-->
<!--              <div class="success-message">支付成功！</div>-->
<!--              <div class="success-desc">插件已激活</div>-->
<!--            </div>-->

<!--            &lt;!&ndash; 支付失败 &ndash;&gt;-->
<!--            <div class="error-section" v-if="paymentError && !qrCodeUrl">-->
<!--              <div class="error-icon">✕</div>-->
<!--              <div class="error-message">{{ errorMessage }}</div>-->
<!--            </div>-->

            <!-- 加载中 -->
            <div class="qr-loading" v-if="loadingQR && !qrCodeUrl">
              <div class="loading-spinner"></div>
              <div>正在生成支付二维码...</div>
            </div>
          </div>

<!--          &lt;!&ndash; 支付状态提示 &ndash;&gt;-->
<!--          <div class="payment-status-hint" v-if="!paymentSuccess && !paymentError && qrCodeUrl">-->
<!--            <div class="status-pending">-->
<!--              <el-icon><Timer /></el-icon>-->
<!--              <span>支付二维码有效时间：5分钟</span>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <!-- 灰色按钮区域 -->
        <div class="button-container">
          <button class="gray-btn cancel-btn" @click="openDialog('faq')">
            订阅说明
          </button>
          <button class="gray-btn confirm-btn" @click="openDialog('terms')">
            服务条款
          </button>
        </div>
      </div>
    </div>

    <!-- 订阅说明弹窗 -->
    <el-dialog
        v-model="showFAQDialog"
        @closed="closeDialog"
        title="订阅说明"
        top="10px"
        width="450px"
        class="faq-dialog"

    >
      <div class="dialog-content">
        <h3>Q1: 订阅后如何激活插件？</h3>
        <p>支付成功后，插件将自动激活，无需手动操作</p>

        <h3>Q2: 订阅可以退款吗？</h3>
        <p>虚拟商品一经激活，概不退款。请在支付前确认需求</p>

        <h3>Q3: 订阅有效期如何计算？</h3>
        <p>从支付成功时开始计算，到期后如需继续使用，请重新订阅</p>

        <!-- 添加更多内容以测试滚动 -->
        <h3>Q4: 如何查看订阅剩余时间？</h3>
        <p>在插件主界面可以查看订阅剩余时间，系统会在到期前3天提醒</p>

        <h3>Q5: 订阅可以在多台设备使用吗？</h3>
        <p>每个订阅仅限绑定一个设备使用，如需多设备使用请购买多个订阅</p>

        <h3>Q6: 插件更新需要额外付费吗？</h3>
        <p>在订阅有效期内，所有功能更新和技术支持均为免费</p>

        <h3>Q7: 支付遇到问题怎么办？</h3>
        <p>如遇支付问题，请截图保存错误信息，联系客服微信：18925330037</p>
      </div>

    </el-dialog>

    <!-- 服务条款弹窗同样修改 -->
    <el-dialog
        v-model="showTermsDialog"
        @closed="closeDialog"
        title="服务条款"
        top="10px"
        width="450px"
    >
      <div class="dialog-content">
        <ol>
          <li>1.用户需保证使用本插件的合法性，不得用于任何违法活动</li>
          <li>2.禁止将插件用于商业倒卖、破解、二次分发等行为</li>
          <li>3.订阅服务不可转让，仅限购买账号使用</li>
          <li>4.由于用户不当操作导致的损失，开发者不承担责任</li>
          <li>5.开发者有权根据实际情况调整价格和服务内容</li>
          <li>6.订阅到期后未续费，将无法使用插件功能</li>
          <li>7.用户需妥善保管账号信息，防止泄露</li>
          <li>8.最终解释权归开发者所有</li>
          <li>9.本服务条款遵守中华人民共和国相关法律法规</li>
          <li>10.如发生争议，双方应友好协商解决</li>
          <li>11.协商不成时，提交有管辖权的人民法院诉讼解决</li>
          <li>12.本条款自用户购买订阅时生效</li>
          <li>13.开发者保留随时修改服务条款的权利</li>
          <li>14.修改后的条款将在官网公示，继续使用视为接受</li>
        </ol>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import QRCode from 'qrcode'

const loading = ref(false)
const loadingQR = ref(false)

// 支付相关状态
const qrCodeUrl = ref('')
const paymentSuccess = ref(false)
const paymentError = ref(false)
const errorMessage = ref('')
const countdown = ref(300) // 5分钟倒计时
const orderNo = ref('')
const pollInterval = ref(null)
const countdownTimer = ref(null)

// 支付成功遮罩层
const showGlobalOverlay = ref(false)

// 弹窗相关变量
const showFAQDialog = ref(false)
const showTermsDialog = ref(false)

// EXE传入的参数
const exeParams = ref({
  code: '',
  version: '',
  token: ''
})

// 在打开弹窗时调用
const openDialog = (type) => {
  if (type === 'faq') {
    showFAQDialog.value = true;
  } else if (type === 'terms') {
    showTermsDialog.value = true;
  }

  // 防止背景滚动
  document.body.style.overflow = 'hidden';
}

// 在关闭弹窗时调用
const closeDialog = () => {
  document.body.style.overflow = '';
}

// 选中的套餐
const selectedPlan = ref(30) // 默认选择30天套餐
const selectedPlanData = ref(null)

// 套餐数据
const plans = ref([
  {
    days: 30,
    name: '月卡套餐',
    price: '0',
    originalPrice: '198',
    desc: '短期灵活'
  },
  {
    days: 90,
    name: '季卡套餐',
    price: '0',
    originalPrice: '388',
    desc: '性价比高'
  },
  {
    days: 365,
    name: '年卡套餐',
    price: '0',
    originalPrice: '1288',
    desc: '最优惠'
  }
])

// 二维码过期相关
const qrCodeGeneratedTime = ref(0)
const isQrCodeExpired = ref(false)
const qrCodeExpireCheckInterval = ref(null)
const QR_CODE_EXPIRE_TIME = 5 * 60 * 1000 // 5分钟过期时间（毫秒）
const paymentStatus = ref('pending') // pending, success, error


// 获取EXE传入的参数
const getExeParams = () => {
  // 这里使用固定值，你可以改为从URL获取
  // return {
  //   code: 'ebt1002',
  //   version: '2.5.32',
  //   token: 'eyJhbGciOiJIUzI1NiJ9.eyJlbmNyeXB0ZWRVc2VySWQiOiI4b0pHNS8rcTR5SjZ3V3h6T3FaVUV0NHU2Ky9pbUpSMFl4RTc2Z3J2SnVBPSIsInVzZXJuYW1lIjoiMTAwMSIsInN1YiI6IjEwMDEiLCJpYXQiOjE3NjY1NDYxMTIsImV4cCI6MTc2NjU0OTcxMn0.qhB7oCnZOAFZ3Ge9Rhs3YFYIXR9YBDGna_T3AI3otwI'
  // }

  return {
    code: 'EBT1002',
    version: '2.5.7',
    token: 'eyJhbGciOiJIUzI1NiJ9.eyJlbmNyeXB0ZWRVc2VySWQiOiJ4VTkxSWdFTGlFMVF2TGI2b2ZTdzY1OHJBWk92YWNSS3FCbG05UlI3dkZzPSIsInVzZXJuYW1lIjoidGV4dDgwOSIsInN1YiI6InRleHQ4MDkiLCJpYXQiOjE3NjY1NDQ5MzYsImV4cCI6MTc2NjU0ODUzNn0.Jp2WNWyHrNPCnYLJTw95oKk6zvZutZ6YN_rc4jTsrYE'
  }

  // return {
  //   code: getUrlParam('code'),
  //   version: getUrlParam('version'),
  //   token: getUrlParam('token')
  // }
}

// EXE专用的请求封装
const exeRequest = {
  async request(url, method = 'GET', data = null, params = null) {
    try {
      const headers = {
        'Content-Type': 'application/json',
      }

      // 添加token到header
      if (exeParams.value.token) {
        headers['Authorization'] = `Bearer ${exeParams.value.token}`
      }

      // 处理查询参数
      let requestUrl = `/api${url}`
      // let requestUrl = `http://localhost:8082/api${url}`
      if (params) {
        const queryString = new URLSearchParams(params).toString()
        requestUrl += `?${queryString}`
      }

      const config = {
        method,
        headers
      }

      if (data && (method === 'POST' || method === 'PUT')) {
        config.body = JSON.stringify(data)
      }

      const response = await fetch(requestUrl, config)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      return result
    } catch (error) {
      console.error('请求错误:', error)
      throw error
    }
  },

  get(url, config = {}) {
    const { params } = config
    return this.request(url, 'GET', null, params)
  },

  post(url, data, config = {}) {
    const { params } = config
    return this.request(url, 'POST', data, params)
  }
}

// 根据产品编码和版本号获取产品ID
const getProductIdByCodeAndVersion = async () => {
  try {
    const response = await exeRequest.get('/plugin/getProductId', {
      params: {
        productCode: exeParams.value.code,
        version: exeParams.value.version
      }
    });

    if (response.code === '200') {

      return response.data; // 返回产品ID
    } else {
      console.error('获取产品ID失败:', response.message);
      return null;
    }
  } catch (error) {
    console.error('获取产品ID失败:', error);
    return null;
  }
};

// 获取产品价格信息
const fetchProductPricing = async () => {
  if (!exeParams.value.code) {
    console.error('缺少产品编码')
    return
  }

  loading.value = true
  try {
    const response = await exeRequest.get("/plugin/pricing/by-product-code", {
      params: {
        productCode: exeParams.value.code
      }
    })

    if (response.code === '200' && response.data) {
      const data = response.data

      plans.value = plans.value.map(plan => {
        let price = '0'
        let originalPrice = '0'

        switch (plan.days) {
          case 30:
            price = data.price30Days || plan.price || '0'
            // 这里修改：如果后端返回的原价为0或不存在，使用前端初始的原价
            originalPrice = data.originalPrice30Days && data.originalPrice30Days !== '0' && data.originalPrice30Days !== 0
                ? data.originalPrice30Days
                : plan.originalPrice || '0'
            break
          case 90:
            price = data.price90Days || plan.price || '0'
            originalPrice = data.originalPrice90Days && data.originalPrice90Days !== '0' && data.originalPrice90Days !== 0
                ? data.originalPrice90Days
                : plan.originalPrice || '0'
            break
          case 365:
            price = data.price365Days || plan.price || '0'
            originalPrice = data.originalPrice365Days && data.originalPrice365Days !== '0' && data.originalPrice365Days !== 0
                ? data.originalPrice365Days
                : plan.originalPrice || '0'
            break
        }

        return {
          ...plan,
          price: parseFloat(price).toFixed(2),
          originalPrice: parseFloat(originalPrice).toFixed(2)
        }
      })

      // 找到30天套餐并设置为选中
      const plan30 = plans.value.find(p => p.days === 30)
      if (plan30) {
        selectedPlanData.value = plan30

        // 自动为30天套餐生成二维码
        setTimeout(() => {
          generateQRCode()
        }, 500)
      }

    } else {
      console.error('获取价格失败:', response.message)
    }
  } catch (error) {
    console.error('获取产品价格失败:', error)
  } finally {
    loading.value = false
  }
}

// 选择套餐
const selectPlan = async (plan) => {
  // 关闭旧订单并清理
  await cleanupBeforeNewPlan()

  selectedPlan.value = plan.days
  selectedPlanData.value = plan

  // 重置支付状态
  clearTimers()
  qrCodeUrl.value = ''
  paymentSuccess.value = false
  paymentError.value = false
  errorMessage.value = ''
  paymentStatus.value = 'pending'

  // 为新选择的套餐生成二维码
  generateQRCode()
}

// 创建支付订单
const createPaymentOrder = async () => {
  if (!selectedPlanData.value.days || !selectedPlanData.value.price) {
    throw new Error('支付参数不完整')
  }

  const productId = await getProductIdByCodeAndVersion();

  if (!productId) {
    ElMessage.error('无法获取插件ID，请稍后重试');
    return;
  }

  try {
    const response = await exeRequest.post('/pay/createQrCode', {
      productId: productId,
      productName: exeParams.value.code,
      days: selectedPlanData.value.days,
      amount: selectedPlanData.value.price,
      description: `购买${selectedPlanData.value.name} ${selectedPlanData.value.days}天使用权`,
      paymentType: 'wechat_native'
    })

    if (response.code === '200' && response.data) {
      const data = response.data
      orderNo.value = data.outTradeNo || data.orderNo

      // 生成二维码
      if (data.qrCodeUrl) {
        const qrDataURL = await QRCode.toDataURL(data.qrCodeUrl, {
          width: 220,
          margin: 1
        })
        qrCodeUrl.value = qrDataURL
      }

      // 记录二维码生成时间
      qrCodeGeneratedTime.value = Date.now()
      isQrCodeExpired.value = false

      // 开始轮询支付状态
      startPolling()
      // 开始倒计时
      startCountdown()
      // 启动二维码过期检查
      startQrCodeExpireCheck()

      return true
    } else {
      throw new Error(response.message || '创建订单失败')
    }
  } catch (error) {
    console.error('创建支付订单失败:', error)
    paymentError.value = true
    paymentStatus.value = 'error'
    errorMessage.value = error.message || '创建订单失败，请重试'
    return false
  }
}

// 轮询支付状态
const startPolling = () => {
  if (pollInterval.value) clearInterval(pollInterval.value)

  pollInterval.value = setInterval(async () => {
    try {
      if (!orderNo.value) return

      const response = await exeRequest.get(`/pay/pollStatus/${orderNo.value}`)

      if (response.code === '200' && response.data) {
        if (response.data.paid === true || response.data.status === 'PAID') {
          // 支付成功
          clearInterval(pollInterval.value)
          clearInterval(countdownTimer.value)
          clearInterval(qrCodeExpireCheckInterval.value)

          paymentSuccess.value = true
          paymentStatus.value = 'success'
          qrCodeUrl.value = ''

          // 显示全局遮罩层
          setTimeout(() => {
            showGlobalOverlay.value = true
          }, 500) // 延迟500ms显示，让用户看到二维码区域的成功提示

          // 通知EXE客户端支付成功
          notifyExeClient('payment_success', {
            orderNo: orderNo.value,
            productCode: exeParams.value.code,
            days: selectedPlanData.value.days
          })
        } else if (response.data.status === 'CLOSED' || response.data.status === 'FAILED') {
          // 支付失败或关闭
          clearInterval(pollInterval.value)
          clearInterval(countdownTimer.value)
          clearInterval(qrCodeExpireCheckInterval.value)

          paymentError.value = true
          paymentStatus.value = 'error'
          errorMessage.value = '支付已取消或失败'
        }
      }
    } catch (error) {
      console.error('轮询支付状态失败:', error)
    }
  }, 3000)
}

// 开始倒计时
const startCountdown = () => {
  if (countdownTimer.value) clearInterval(countdownTimer.value)

  countdown.value = 300
  countdownTimer.value = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--
    } else {
      // 倒计时结束
      clearInterval(countdownTimer.value)
      clearInterval(pollInterval.value)
      clearInterval(qrCodeExpireCheckInterval.value)

      paymentError.value = true
      paymentStatus.value = 'error'
      errorMessage.value = '支付超时，请重新支付'
    }
  }, 1000)
}

// 启动二维码过期检查
const startQrCodeExpireCheck = () => {
  if (qrCodeExpireCheckInterval.value) clearInterval(qrCodeExpireCheckInterval.value)

  qrCodeExpireCheckInterval.value = setInterval(async () => {
    const now = Date.now()
    const elapsedTime = now - qrCodeGeneratedTime.value

    if (elapsedTime >= QR_CODE_EXPIRE_TIME && paymentStatus.value === 'pending') {
      isQrCodeExpired.value = true
      clearTimers()

      // 二维码过期时关闭订单
      await closeOrder()
    }
  }, 1000)
}

// 格式化时间
const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

// 生成二维码
const generateQRCode = async () => {
  if (!selectedPlanData.value) return

  // 清理旧状态
  await cleanupBeforeNewPlan()

  loadingQR.value = true
  qrCodeUrl.value = ''
  paymentSuccess.value = false
  paymentError.value = false
  errorMessage.value = ''
  paymentStatus.value = 'pending'
  isQrCodeExpired.value = false

  // 清理之前的定时器
  clearTimers()

  const success = await createPaymentOrder()

  if (!success) {
    loadingQR.value = false
  } else {
    loadingQR.value = false
  }
}

// 刷新二维码（过期时点击遮盖层调用）
const refreshQrCode = async () => {
  if (isQrCodeExpired.value) {
    // 关闭旧订单
    if (orderNo.value) {
      await closeOrder()
    }

    isQrCodeExpired.value = false
    generateQRCode()
  }
}

// 清理旧订单和轮询
const cleanupBeforeNewPlan = async () => {
  // 关闭旧的订单
  if (orderNo.value) {
    await closeOrder()
  }

  // 清理定时器
  clearTimers()

  // 重置状态
  qrCodeUrl.value = ''
  orderNo.value = ''
}

// 关闭订单（如果存在）
const closeOrder = async () => {
  if (!orderNo.value) return

  try {
    await exeRequest.post(`/pay/closeOrder/${orderNo.value}`)

  } catch (error) {
    console.warn('关闭订单失败:', error)
  }
}

// 重置支付状态
const resetPaymentState = () => {
  paymentSuccess.value = false
  paymentError.value = false
  errorMessage.value = ''
  paymentStatus.value = 'pending'
  countdown.value = 300
}

// 清理定时器
const clearTimers = () => {
  if (pollInterval.value) {
    clearInterval(pollInterval.value)
    pollInterval.value = null
  }
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
    countdownTimer.value = null
  }
  if (qrCodeExpireCheckInterval.value) {
    clearInterval(qrCodeExpireCheckInterval.value)
    qrCodeExpireCheckInterval.value = null
  }
}

// 通知EXE客户端
const notifyExeClient = (type, data) => {
  if (window.parent && window.parent.postMessage) {
    window.parent.postMessage({
      type: type,
      data: data
    }, '*')
  }
}

// 关闭遮罩层的方法
const closeOverlay = () => {
  showGlobalOverlay.value = false
  // 可选：关闭窗口或跳转
  if (window.close) {
    window.close()
  }
}

// 取消按钮处理
const handleCancel = async () => {
  // 关闭订单
  if (orderNo.value) {
    await closeOrder()
  }

  clearTimers()

  // 通知EXE客户端取消
  if (window.parent && window.parent.postMessage) {
    window.parent.postMessage({
      type: 'payment_cancel',
      params: exeParams.value
    }, '*')
  }

  // 尝试关闭窗口
  if (window.close) {
    window.close()
  }
}

// 初始化
onMounted(() => {

  document.title = ''

  // 立即设置默认选中的套餐
  const defaultPlan = plans.value.find(p => p.days === 30)
  if (defaultPlan) {
    selectedPlanData.value = { ...defaultPlan }
  }
    exeParams.value = getExeParams()

  console.log('EXE传入的参数:', exeParams.value)

  if (!exeParams.value.code) {
    console.error('缺少产品编码参数')
    return
  }

  if (!exeParams.value.token) {
    console.error('缺少token参数')
    return
  }

  fetchProductPricing()
})

// 组件卸载时清理
onUnmounted(async () => {
  // 关闭未完成的订单
  if (orderNo.value && paymentStatus.value === 'pending') {
    await closeOrder()
  }

  clearTimers()
})

// 监听窗口消息
window.addEventListener('message', (event) => {
  const { type, data } = event.data

  switch (type) {
    case 'update_token':
      exeParams.value.token = data.token
      break
    case 'close_window':
      if (window.close) window.close()
      break
  }
})
</script>

<style scoped>
.exe-pricing-container {
  min-width: 720px;
  min-height: 220px;
  width: 100vw;
  height: 100vh;
  max-width: 1600px;
  max-height: 800px;
  background: white;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-layout {
  display: flex;
  flex: 1;
  gap: 20px;
  height: 100%;
}

/* 左边区域：套餐选择 (3/4) */
.left-section {
  flex: 3;
  display: flex;
  flex-direction: column;
  height: 98%;
  min-width: 0;
  background: white;
  border-radius: 12px;

  overflow: hidden;
}

.period-selection-section {
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 横向周期选择容器 */
.period-horizontal-container {
  display: flex;
  gap: 10px;
  flex: 1;
  align-items: stretch;
  justify-content: center;
}

/* 横向周期选项 */
.period-horizontal-option {
  flex: 1;
  position: relative;
  padding: 10px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 80px;

  display: -webkit-flex; /* 添加 Webkit 前缀 */
  -webkit-flex-direction: column; /* 添加 Webkit 前缀 */

  &:hover {
    border-color: #6366f1;
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(99, 102, 241, 0.1);
  }

  &.active {
    border-color: #6366f1;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%);
    box-shadow: 0 10px 25px rgba(99, 102, 241, 0.15);
  }

  &.popular {
    border-color: #f59e0b;

    .period-top-badge {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    }

    &.active {
      border-color: #f59e0b;
      background: linear-gradient(135deg, rgba(245, 158, 11, 0.05) 0%, rgba(217, 119, 6, 0.05) 100%);
    }
  }

  &.premium {
    border-color: #10b981;

    .period-top-badge {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    &.active {
      border-color: #10b981;
      background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(5, 150, 105, 0.05) 100%);
    }
  }
}

/* 顶部角标 */
.period-top-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
  z-index: 1;
}

/* 主要内容 */
.period-main-content {
  width: 100%; /* 添加 */
  height: 100%; /* 添加 */
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-justify-content: center;
  -webkit-align-items: center;

  .period-label {
    font-size: 14px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 8px;
  }

  .period-price {
    margin-bottom: 6px;

    .currency {
      font-size: 16px;
      font-weight: 600;
      color: #6366f1;
    }

    .amount {
      font-size: 24px;
      font-weight: 700;
      color: #6366f1;
      margin-left: 2px;
    }
  }

  .period-days {
    font-size: 12px;
    color: #94a3b8;
    margin-bottom: 4px;
  }

  .period-desc {
    font-size: 11px;
    color: #64748b;
    margin-bottom: 4px;
  }

  .plan-original {
    font-size: 10px;
    color: #a0aec0;
    text-decoration: line-through;
    margin-top: 2px;
  }
}

/* 选中标记 */
.period-check-mark {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-icon {
    color: white;
    font-size: 14px;
    font-weight: bold;
  }
}

/* 右边区域：二维码支付 (1/4) */
.right-section {
  flex: 1;
  height: 98%;
  min-width: 195px;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
}

/* 支付金额区域 */
.payment-amount {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  padding: 0 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #bae6fd;
  text-align: center;
}

.amount-label {
  font-size: 12px;
  color: #0369a1;
  font-weight: 400;

}

.amount-value {
  font-size: 24px;
  font-weight: 600;
  color: #d40c0c;

}

/* 二维码区域 */
.qrcode-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 2px;
}

.qrcode-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 2px;
  text-align: center;
}

.qrcode-header .el-icon {
  color: #07c160;
}

/* 二维码显示区域 */
.qrcode-display-area {
  flex: 1;
  margin: 0 25px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  position: relative;
  margin-bottom: 10px;

}

/* 二维码包装器 */
.qrcode-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-image {
  width: 100%;
  max-width: 130px;
  aspect-ratio: 1;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

/* 遮罩层样式 */
.success-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  animation: fadeIn 0.5s ease;
}

.success-content {
  text-align: center;

  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-justify-content: center;
  -webkit-align-items: center;

  .success-text {
    font-size: 18px;
    font-weight: 700;
    color: #52c41a;
    margin: 10px 0 5px;
  }

  .success-hint {
    font-size: 12px;
    color: #64748b;
  }
}

/* 二维码过期遮罩 */
.expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  animation: fadeIn 0.5s ease;
  cursor: pointer;
  transition: all 0.3s ease;
}

.expired-content {
  text-align: center;

  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-justify-content: center;
  -webkit-align-items: center;

  .expired-text {
    font-size: 16px;
    font-weight: 700;
    color: #f56c6c;
    margin: 10px 0 5px;
  }

  .expired-hint {
    font-size: 11px;
    color: #64748b;
  }
}

/* 支付成功/失败区域 */
.success-section,
.error-section {
  text-align: center;
}

.success-icon,
.error-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 10px;
}

.success-icon {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
}

.error-icon {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
  color: white;
}

.success-message,
.error-message {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.success-message {
  color: #2f855a;
}

.error-message {
  color: #c53030;
}

.success-desc {
  font-size: 12px;
  color: #718096;
}

/* 加载中 */
.qr-loading {
  text-align: center;
  color: #718096;
  font-size: 12px;
}

.loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #e2e8f0;
  border-top-color: #4299e1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 支付状态提示 */
.payment-status-hint {
  padding: 10px;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
}

.status-pending {
  color: #f59e0b;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.status-pending .el-icon {
  margin-right: 5px;
  vertical-align: middle;
}

/* 倒计时 */
.countdown {
  text-align: center;
  font-size: 12px;
  color: #718096;
  padding: 8px;
  background: #f7fafc;
  border-radius: 6px;
}

.timer {
  font-weight: bold;
  color: #e53e3e;
  font-family: monospace;
}

/* 按钮区域 */
.button-container {
  display: flex;
  margin-top: 2px;
  display: -webkit-flex;
  display: -ms-flexbox;
  justify-content: space-between;
  align-items: center;
  -webkit-justify-content: space-between;
  -webkit-align-items: center;
  -ms-flex-pack: justify;
  -ms-flex-align: center;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

.gray-btn {
  flex: 1;
  margin: 5px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  /* 移除背景和边框 */
  border: none;
  background: transparent;
  color: #4a5568;
  min-height: 18px;


  -webkit-flex: 1;
  -ms-flex: 1;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.gray-btn:hover:not(:disabled) {
  /* 文字按钮悬停效果 */
  color: #6366f1;
  background: transparent;
  text-decoration: underline;
}

.gray-btn:disabled {
  /* 禁用状态 */
  background: transparent;
  color: #a0aec0;
  cursor: not-allowed;
  text-decoration: none;
}

/* 响应式调整 */
@media (max-width: 900px) {
  .main-layout {
    gap: 10px;
  }

  .period-horizontal-container {
    gap: 10px;
  }


}

@media (max-width: 800px) {

  .exe-pricing-container {
    padding: 2px;
  }

  .period-horizontal-option {
    min-width: 80px;
  }

}

@media (max-height: 400px) {
  .period-horizontal-container {
    align-items: center;
  }

  .period-horizontal-option {
    min-height: 200px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 全局成功遮罩层 */
.global-success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 背景虚化层 */
.overlay-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.overlay-content {
  position: relative;
  z-index: 10000;
  background: white;
  border-radius: 16px;
  padding: 15px; /* 响应式内边距 */
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: overlayFadeIn 0.5s ease;
  max-width: min(300px, 90vw); /* 响应式最大宽度 */
  width: 90%;
  max-height: min(500px, 90vh); /* 响应式最大高度 */
  overflow-y: auto;
  box-sizing: border-box;

  /* 使用 flex 布局确保内容适应 */
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  align-items: center;
  -webkit-justify-content: center;
  -webkit-align-items: center;

}

.overlay-title {
  font-size: 20px; /* 响应式字体大小 */
  font-weight: 700;
  color: #52c41a;
  margin: 5px 0;
  line-height: 1.2; /* 减少行高 */
}

.overlay-description {
  font-size: 12px; /* 响应式字体大小 */
  color: #64748b;
  margin: 5px 0 10px;
  line-height: 1.4;
  max-width: 100%;
  overflow-wrap: break-word; /* 防止文字溢出 */
}

.success-icon-large {
  margin: 5px 0;
  flex-shrink: 0; /* 防止图标被压缩 */
}

.overlay-button {
  background: linear-gradient(135deg, #1b1fe6 0%, #2f50bb 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 5px 15px; /* 响应式内边距 */
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.2);
  margin-top: 5px;
  flex-shrink: 0; /* 防止按钮被压缩 */
}

.overlay-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgb(19, 69, 230);
}

.overlay-button:active {
  transform: translateY(0);
}

/* 遮罩层动画 */
@keyframes overlayFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}


/* 对话框样式 */
.dialog-content {
  display: block;
  max-height: 178px; /* 内容区域最大高度 */
  overflow-y: auto;
}

.dialog-content h3 {
  display: block;
  color: #333;
  margin: 5px 0;
  font-size: 14px;
}

.dialog-content p {
  display: block;
  color: #666;
  margin: 2px 0 10px;
  line-height: 1.5;
  font-size: 12px;
}

.dialog-content ol {
  display: block;
  padding: 0;
  margin: 0;
  color: #666;
}

.dialog-content li {
  display: block;
  margin-bottom: 8px;
  line-height: 1.5;
}


/* 添加滚动条样式 */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 弹窗遮罩层虚化效果 */
.exe-pricing-container :deep(.el-overlay) {
  backdrop-filter: blur(5px) !important; /* 背景模糊效果 */
  -webkit-backdrop-filter: blur(5px) !important; /* Webkit兼容 */

  /* 确保遮罩层正确显示 */
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  z-index: 2000 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

:deep(.el-dialog) {
  margin-bottom: 0 !important;
  padding: 0 0 0 10px !important;

  width: 450px !important;  /* 强制宽度 */
  max-width: 450px !important;
  margin: 0 auto !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  -webkit-transform: translate(-50%, -50%) !important;

  /* 确保弹窗显示 */
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  z-index: 2001 !important;

  /* 移除可能影响的内外边距 */
  border-radius: 4px !important;
  overflow: hidden !important;
}

/* 对话框头部容器样式 */
.exe-pricing-container :deep(.el-dialog__header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 !important;
  padding: 0 !important;

  min-height: 30px; /* 设置最小高度，避免太扁 */
  height: 30px; /* 固定高度 */
  box-sizing: border-box; /* 确保padding和border包含在高度内 */


  display: -webkit-flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -ms-display: flexbox;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  -webkit-align-items: center;
  -ms-flex-align: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

}

/* 对话框标题样式 */
.exe-pricing-container :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 700;
  color: #6366f1;

  margin: 0; /* 移除标题的默认外边距 */
  line-height: 28px; /* 行高等于容器高度，确保垂直居中 */
  flex: 1; /* 占据剩余空间 */

  -webkit-flex: 1;
  -ms-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
}

/* 关闭图标的样式 */
.exe-pricing-container :deep(.el-dialog__headerbtn) {
  position: relative;
  order: 2; /* 将关闭按钮放到右侧 */
  margin: 0; /* 移除关闭按钮的外边距 */
  padding: 0; /* 移除关闭按钮的内边距 */
  height: 30px; /* 与容器高度一致 */
  width: 30px; /* 固定宽度 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* 防止按钮被压缩 */

  -webkit-order: 2;
  -ms-order: 2;
  display: -webkit-flex;
  display: -ms-flexbox;
  -webkit-align-items: center;
  -ms-flex-align: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
}

/* 悬停时关闭图标的样式 */
.exe-pricing-container :deep(.el-dialog__headerbtn:hover .el-dialog__close) {
  color: #ef4444 !important; /* 红色 - 使用 !important 确保覆盖默认样式 */
}


</style>